module.exports = __webpack_public_path__ + "img/swift-2021.75dadb6d.svg";